import { render, staticRenderFns } from "./ModalSelecionarCamadas.vue?vue&type=template&id=435290c3&scoped=true&lang=pug"
import script from "./ModalSelecionarCamadas.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarCamadas.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecionarCamadas.vue?vue&type=style&index=0&id=435290c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435290c3",
  null
  
)

export default component.exports